import * as React from 'react'
import { IconsModel } from './iconsModel'

function SvgElevator(
	{
		color,
		width = 50,
		height = 50
	}: IconsModel
) {
	return (
		<svg  width={width} height={height}>
			<path
				d="M41.756 14.37v33.678h-13.7v-1.513h12.187V15.883H9.513v30.652h14.57V18.343h1.512v29.705H8V14.37h33.756zM39.218 1.504l-6.338 8.45-6.338-8.45h12.676zM16.798 1l6.337 8.45H10.46L16.798 1zm0 2.522l-3.312 4.415h6.623l-3.311-4.415zm19.394-.505h-6.624l3.312 4.416 3.312-4.416z"
				fill={color}
				fillRule="evenodd"
			/>
		</svg>
	)
}

export default SvgElevator
